import { aboutInfo } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              {aboutInfo.title}
            </h2>
          </div>
          <div className="rounded-2xl bg-background-50 border border-background-200/60 p-6 md:p-10">
            <div className="space-y-5">
              {aboutInfo.paragraphs.map((p, idx) => (
                <p key={idx} className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {p}
                </p>
              ))}
            </div>
            <div className="flex flex-wrap gap-4 mt-8">
              <div className="flex-1 min-w-[140px] text-center p-4 rounded-xl bg-primary-50">
                <div className="text-2xl font-bold text-primary-500 font-heading">1200万+</div>
                <div className="text-xs text-foreground-500 mt-1">原创视频</div>
              </div>
              <div className="flex-1 min-w-[140px] text-center p-4 rounded-xl bg-accent-50">
                <div className="text-2xl font-bold text-accent-500 font-heading">85万+</div>
                <div className="text-xs text-foreground-500 mt-1">活跃创作者</div>
              </div>
              <div className="flex-1 min-w-[140px] text-center p-4 rounded-xl bg-secondary-50">
                <div className="text-2xl font-bold text-secondary-500 font-heading">5000+</div>
                <div className="text-xs text-foreground-500 mt-1">每日更新</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}